module.exports = __webpack_public_path__ + "static/media/kinfolk-recap-apolis-journal-3.ed4b5591.jpg";